import React from 'react';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  Label,
  Bar,
  BarChart,
} from 'recharts';

const CustomTooltip = ({
  active = false,
  payload = [],
  label = undefined,
}: {
  active?: any;
  payload?: any;
  label?: any;
}) => {
  if (active && payload && payload.length) {
    const backgroundColor = payload[0].color;
    const backgroundColor2 = payload[1].color;

    return (
      <div
        className={
          'bg-white rounded-sm-5 shadow-tooltip text-xs py-2.5 px-3 flex flex-col gap-1.5 items-start justify-start font-jamjuree'
        }
      >
        <p className="font-medium text-xs opacity-30">{label}</p>
        <div className="flex flex-row gap-2 items-center">
          <div
            style={{
              backgroundColor,
            }}
            className={'w-2 h-2 rounded-[50%]'}
          ></div>
          <div className={'flex items-center justify-start gap-0.5'}>
            <p className="font-medium">{`${payload[0].name} -`}</p>{' '}
            <p className="font-bold text-sm">{`${payload[0].value}`}</p>
          </div>
        </div>
        <div className="flex flex-row gap-2 items-center">
          <div
            style={{
              backgroundColor: backgroundColor2,
            }}
            className={'w-2 h-2 rounded-[50%]'}
          ></div>
          <div className={'flex items-center gap-0.5'}>
            <p className="font-medium">{`${payload[1].name} -`}</p>
            {'  '}
            <p className="font-bold text-sm">{`${payload[1].value}`}</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export const TotalProcessedBarChart = ({
  dataKey = '',
  data = [],
  groupBy = 'day',
  dataKeyStack = '',
  hideLabel,
  minHeight = '350px',
  height = 300,
}) => {
  const isDayRange = groupBy === 'day';
  const isTimeFormat = ['firstResponseTimeAvg', 'resolutionTimeAvg', 'responseTimeAvg'].includes(
    dataKey,
  );
  let YAxisLabel = isTimeFormat ? 'Min' : 'Tickets';
  YAxisLabel = dataKey === 'resolutionRate' ? '%' : YAxisLabel;
  YAxisLabel = ['aiRepliesSent', 'aiRepliesPerProcessedTicket'].includes(dataKey)
    ? 'Replies'
    : YAxisLabel;

  const tickValues = data
    .filter((_, i) => i % Math.ceil(data.length / 10) === 0)
    .map((d) => d.formattedGroup);

  return (
    <ResponsiveContainer width="100%" height="100%" minHeight={minHeight}>
      <BarChart
        width={500}
        height={height}
        data={data}
        margin={{
          top: 0,
          right: 50,
          left: 10,
          bottom: 13,
        }}
      >
        <CartesianGrid vertical={false} strokeDasharray="1 1" />
        <XAxis
          dataKey="formattedGroup"
          ticks={tickValues}
          tick={{
            fontSize: 11,
            fontFamily: 'Bai Jamjuree',
            fontWeight: 500,
            opacity: 0.3,
            dy: 7,
          }}
          tickFormatter={(value) => {
            if (typeof value === 'string' && value.includes(':')) {
              return value.replace(':00', '').replace(/^0/, '');
            }
            return value;
            // return value.split(',')[0];
          }}
        >
          {!hideLabel && (
            <Label
              value={isDayRange ? 'Days' : 'Hours'}
              offset={-10}
              position="insideBottomRight"
              className={'fill-ebony text-sm font-semibold'}
            />
          )}
        </XAxis>
        <YAxis
          tick={{
            fontSize: 11,
            fontFamily: 'Bai Jamjuree',
            fontWeight: 500,
            opacity: 0.3,
            dx: -7,
          }}
          allowDecimals={false}
        >
          {!hideLabel && (
            <Label
              value={YAxisLabel}
              offset={10}
              position="top"
              className={'fill-ebony text-sm font-semibold'}
            />
          )}
        </YAxis>
        <Tooltip content={<CustomTooltip />} />
        {Boolean(data.length) && (
          <ReferenceLine
            x={data[parseInt((data.length / 2).toFixed(0)) - 1]['formattedGroup']}
            stroke="#CCCCCC"
            strokeDasharray="1 1"
          />
        )}
        <Bar barSize={'7%'} name={'Resolved'} dataKey={dataKey} stackId="a" fill="#564BA5" />
        <Bar barSize={'7%'} name={'Escalated'} dataKey={dataKeyStack} stackId="a" fill="#EEBCE5" />
      </BarChart>
    </ResponsiveContainer>
  );
};
